import { FC } from 'react'
import FollowControl, { FollowControlProps } from '.'

import useFollowControlActions from './hooks/useFollowControlActions'
import ActionsDropdown from '../ActionsDropdown'
import { useIsOwnProfile } from '@wellesley/user'

export type FollowWithActionsProps = FollowControlProps

const FollowWithActions: FC<FollowWithActionsProps> = (props) => {
  const isOwnProfile = useIsOwnProfile(props.user.id)

  const [actions] = useFollowControlActions({ ...props, isOwnProfile })

  if (isOwnProfile) return null

  return (
    <>
      <div className="gap-xxxs flex items-center">
        <FollowControl {...props} size={props.size || 's'} />
        <ActionsDropdown
          actions={actions}
          mobileBehavior="dropdown"
          triggerVariant="tertiary"
          triggerClass="flex h-auto items-center justify-center border-gray-700 p-1.5 focus-visible:ring-0 focus-visible:ring-transparent"
        />
      </div>
    </>
  )
}

export default FollowWithActions
